import { useAppSelector } from "../app/hooks"

const useAuth = () => {
  const isLoggedIn = useAppSelector((state) => state.auth.isLoggedIn)

  return isLoggedIn
}

export default useAuth
